import { useEffect, useRef } from 'react';
import { trackProductEvent } from '@/lib/analytics';

// One-use, in-memory navigation intent: no cookie, identity, URL or stored visitor ID.
// Deliberately same-tab only; new tabs/reloads and direct entries are unattributed.
let pendingEntry = null;
export const landingEvent = (event, lang, placement) => trackProductEvent(
  event, { source: 'landing_page', ...(placement ? { placement } : {}) },
  { locale: lang, firstPartyOnly: true },
);
export const beginLandingEntry = (lang, placement) => { pendingEntry = { lang, placement }; };

export function useLandingPageView(lang) {
  const lastLocale = useRef(null);
  useEffect(() => {
    if (lastLocale.current === lang) return;
    lastLocale.current = lang;
    pendingEntry = null;
    landingEvent('landing_page_view', lang);
  }, [lang]);
}

export function useCalculatorLandingEntry(lang) {
  useEffect(() => {
    const entry = pendingEntry;
    pendingEntry = null;
    if (entry?.lang === lang) {
      window.scrollTo(0, 0);
      landingEvent('calculator_started_from_landing', lang, entry.placement);
    }
  }, [lang]);
}